import ReactGA from 'react-ga4';

// Inicializar Google Analytics 4
export const initGA4 = (measurementId) => {
  if (process.env.REACT_APP_ENABLE_GA === 'true' && measurementId) {
    ReactGA.initialize(measurementId, {
      debug: process.env.NODE_ENV === 'development',
      testMode: process.env.NODE_ENV === 'test'
    });
    
    console.log('GA4 initialized with ID:', measurementId);
  } else {
    console.log('GA4 disabled or no measurement ID provided');
  }
};

// Enviar página vista
export const trackPageView = (path, title = null) => {
  if (process.env.REACT_APP_ENABLE_GA === 'true') {
    ReactGA.send({ 
      hitType: "pageview", 
      page: path,
      title: title || document.title
    });
  }
};

// Enviar evento personalizado
export const trackEvent = (eventName, parameters = {}) => {
  if (process.env.REACT_APP_ENABLE_GA === 'true') {
    ReactGA.event(eventName, parameters);
  }
};

// Enviar evento con categoría y acción (formato clásico)
export const trackCustomEvent = (category, action, label = null, value = null) => {
  if (process.env.REACT_APP_ENABLE_GA === 'true') {
    const eventData = {
      category,
      action,
    };
    
    if (label) eventData.label = label;
    if (value) eventData.value = value;
    
    ReactGA.event(eventData);
  }
};